import Papa from "papaparse";
import { useState, useEffect } from "react";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { Button, Table, CircularProgress, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import { checkIfAdmin } from "../functions/helpers/user";
const token = localStorage.getItem("token");
const userID = parseInt(localStorage.getItem("userID"));


function BulkRegister() {
    const [parsedData, setParsedData] = useState([]);
    const [school, setschool] = useState()
    const dateFormat = 'dd-mm-yyyy'
    const [isLoading, setIsLoading] = useState(false)
    const [admin, setAdmin] = useState(false)
    const [completed, setCompleted] = useState(false)
    //State to store table Column name
    //comment
    //State to store the values
    const [values, setValues] = useState([]);
    const styling = {
        "textAlign": "center"
    }

    const changeHandler = async (event) => {
        // Passing file data (event.target.files[0]) to parse using Papa.parse
        Papa.parse(event.target.files[0], {
            header: true,
            skipEmptyLines: true,
            complete: async function (results) {

                // Iterating data to get column name and their values

                const newArr =
                    results.data
                        .map(v => ({
                            ...v,
                            "above_age": false,
                            "account_type": "offer",
                            "org_name": "nill",
                            "domain": window.location.hostname,
                            "college": "nil",
                            "course": "nil"
                        }))
                const formattedData = await dateFixer(dateFormat, newArr)
                setParsedData(formattedData)
            },
        })
    };

    const dateFixer = async (format, data) => {
        try {
            let givenFormat = format.toUpperCase()
            let obj = {}
            console.log(givenFormat, format)
            if (givenFormat.length > 8) {
                let arr = givenFormat.split(givenFormat[2])
                for (let field of arr) {
                    obj[field] = arr.indexOf(field)
                }
            }

            for (let student of data) {
                if (student.dob.length > 0) {
                    let tempDate = student.dob.split(givenFormat[2])
                    student.dob = `${tempDate[obj['YYYY']]}-${tempDate[obj['MM']]}-${tempDate[obj['DD']]}`
                }
            }

            return data

        } catch (err) {
            console.log('Error', err.message)
            return '2010-01-02'
        }
    }

    const handleSubmit = async () => {

        let failedRows = []
        setIsLoading(true)



        const arrayWithSchool = parsedData
            .map(v => ({
                ...v,
                dob: v.dob.length > 0 ? v.dob : '2010-01-01',
                "school": school,
            }))


        for (let student of arrayWithSchool) {
            try {
                let res = await fetch(process.env.REACT_APP_API_URL + '/api/user/register/', {
                    method: "POST",
                    headers: {
                        "Content-Type": 'application/json',
                    },
                    body: JSON.stringify(student),
                })
                let data = await res.json()
                console.log(data)
                if (data['status'] === 400) {
                    const errs = data['errors']
                    console.log(errs)
                    let errorString = ''
                    for (let key of Object.keys(errs)) {
                        errorString = errorString + key + ' : ' + errs[key][0] + ' , '
                    }
                    failedRows.push({ student, reason: errorString })
                }
            } catch (err) {
                failedRows.push({ student, reason: err.message })
            }
        }
        const rowsArray = [];
        const valuesArray = [];
        setIsLoading(false)
        console.log(failedRows)
        failedRows.forEach((d) => {
            rowsArray.push(Object.keys(d));
            valuesArray.push(Object.values(d));
        });
        // Filtered Values
        setValues(valuesArray);
        console.log(valuesArray)
        setCompleted(true)

    }

    useEffect(() => {

        // dispatch(registerUser(body))
        async function fetchData() {
            try {
                if (!(await checkIfAdmin(userID, token))) {
                    window.location.href = '/'
                }
                setAdmin(true)
            } catch (err) {
                window.location.href = '/'
                console.log(err)
            }
        }
        fetchData();
        // eslint-disable-next-line 
    }, [])
    if (admin) {
        return (

            <div>
                <div style={{ "textAlign": "center", padding: '25px 0px 0px 0px' }} >
                    <h1 style={{ "color": "rgb(190, 153, 235)" }}>Upload Students Data</h1>
                </div>

                <div style={styling}>
                    {/* File Uploader */}
                    <Button variant="contained" style={{ backgroundColor: 'rgb(190, 153, 235)' }}>
                        <input
                            type="file"
                            name="file"
                            onChange={changeHandler}
                            accept=".csv"
                            style={{ display: "block", margin: "10px auto" }}
                        />
                    </Button>
                    <div className="form-group p-2">
                        <br></br>
                        <small>
                            <label className="text-muted">School Name </label>
                        </small>
                        <input
                            onChange={(e) => setschool(e.target.value)}
                            type="text"
                            className="form-control"
                            placeholder="Enter Name"
                        />
                    </div>
                    <br />
                    {/* <Grid item xs={12} >
                        <TextField
                            label='Enter your date format'
                            style={{ width: 400 }}
                            onChange={(e) => setDateFormat(e.target.value)}
                        >
                        </TextField>
                    </Grid> */}
                    <div hidden={!isLoading}>
                        <div style={{ justifyContent: 'center', display: 'flex', padding: "100px 0px 100px 0px" }}>

                            <CircularProgress />
                        </div>
                    </div>
                    <br></br>
                    <div hidden={isLoading}>
                        <Button variant="contained" style={{ display: "block", margin: "10px auto", backgroundColor: 'rgb(190, 153, 235)' }} onClick={handleSubmit}>
                            Submit
                        </Button>
                    </div>
                    <ToastContainer />
                    <br />
                    <br />
                    <div style={{ width: '70vw', paddingLeft: '15vw' }} hidden={!completed}>
                        <TableContainer component={Paper} >
                            <Table aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Student First Name</TableCell>
                                        <TableCell align="right">Student Last Name</TableCell>
                                        <TableCell align="right">Error</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {values.map((item, i) => (
                                        <TableRow
                                            key={i}
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            <TableCell component="th" scope="row">
                                                {item[0].first_name}
                                            </TableCell>
                                            <TableCell align="right">{item[0].last_name}</TableCell>
                                            <TableCell align="right">{item[1]}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                </div>
            </div >

        );
    } else {
        return (
            <CircularProgress />
        )
    }
}

export default BulkRegister;